import { render, staticRenderFns } from "./ProductShippingFlashSell.vue?vue&type=template&id=45d03c3e&"
import script from "./ProductShippingFlashSell.vue?vue&type=script&lang=js&"
export * from "./ProductShippingFlashSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports